import { Component, OnInit, Output,Input, EventEmitter, ViewChild, ElementRef ,ChangeDetectorRef,HostListener} from '@angular/core';
import { RoleBasedService } from 'src/app/services/role-based.service';
import { GetFeaturesBasedOnRole, RoleBasedFeatureModel } from 'src/app/models/role.model';
import { MessageServiceService } from '../../services/message-service.service';
import {  SidebarModule } from 'primeng';
import { Router } from '@angular/router';
@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit {

  //@ViewChild('sidebarel', { static: true }) sidebar: ElementRef<any>;
  @ViewChild('sidenav',{ static: false }) public sidenav: SidebarModule;
  allMenuFeatures: GetFeaturesBasedOnRole[];
  constructor(private roleBasedService: RoleBasedService,private router: Router,
    private messageService: MessageServiceService, private changesDetectRef: ChangeDetectorRef,) {

  }


  @Output()
  sideClickEvent: EventEmitter<boolean> = new EventEmitter();

  @Input()
  openNav: boolean = false;

  visibleSidebar=false;

  ngOnInit() {
    this.getAllMenuFeatures();
    // setTimeout(function(){ this.getScreenPrivileges(); }, 5000);
  }

  //side menu 
  ngOnChanges(): void {
    //console.log('ngOnChanges open', this.openNav);
  }

  closeSideNav(){
    let elem : HTMLElement = document.getElementById("navbarNav") as HTMLElement;
    elem.click();
  }
  
  getAllFeaturesByRoleIdObject: RoleBasedFeatureModel[];
  getAllFeatures() {
    this.roleBasedService.getFeaturesBasedOnRoleId()
      .subscribe((res: any) => {
        if (res.isSuccess) {
          this.getAllFeaturesByRoleIdObject = res.response;
          this.getAllMenuFeatures();
        }
      }, error => {
        console.log("ohhh1");
        this.messageService.showError();
      });
  }

  getAllMenuFeatures() {
    
    this.roleBasedService.getFeaturesBasedOnRoleId()
      .subscribe(res => {
        if (res.response.length > 0)
          this.allMenuFeatures = res.response;
          // console.log('nav main obj: ',this.allMenuFeatures);
          localStorage.setItem("FeatureActions", null)
          localStorage.setItem("FeatureActions",  JSON.stringify(this.allMenuFeatures));
         // console.log('nav: ',JSON.parse(localStorage.getItem("FeatureActions")));
          this.changesDetectRef.detectChanges();
        this.generateRoleMenuObject(this.allMenuFeatures)
      }, error => {        
        this.messageService.showErrorMessage("Unable to retrieve side menu data from server ");
      })
  }

  sideMenuObject = [];
  generateRoleMenuObject(menuObj) {
    let directMenu = [];
    if(!menuObj){
      this.router.navigate(['/base/custom-message']);
      return
    }
    for (let menu of menuObj) {
      if (menu.parentId == 0) {
        directMenu.push(menu);
      }
      else {
        let existFlag = false;
        for (let dObj of directMenu) {
          if (dObj.menuId == menu.menuId) {
            existFlag = true;
          }
        }
        if (!existFlag) {
          directMenu.push(menu);
        }
      }
    }
    for (let mainMenu of directMenu) {
      let tempObj = mainMenu;
      if (mainMenu.parentId != 0) {
        let subMenuObj = [];
        for (let subMenu of menuObj) {
          if (subMenu.parentId == mainMenu.parentId) {
            subMenuObj.push(subMenu)
          }
        }
        tempObj = {
          roleId: mainMenu.roleId,
          roleName: mainMenu.roleName,
          featureId: mainMenu.featureId,
          featureName: mainMenu.featureName,
          url: mainMenu.url,
          menuIcon: mainMenu.menuIcon,
          orderId: mainMenu.orderId,
          parentId: mainMenu.parentId,
          menuId: mainMenu.menuId,
          menuName: mainMenu.menuName,
          menuFocusId: mainMenu.menuName.replace(/\s/g, ''),
          subMenu: subMenuObj,
          actions: mainMenu.actions
        }
      }
      if(tempObj.subMenu && tempObj.subMenu.length !=0){
        tempObj.subMenu.sort((a,b) => (a.orderId > b.orderId) ? 1 : ((b.orderId > a.orderId) ? -1 : 0));
      }
      this.sideMenuObject.push(tempObj);
    }
    this.sideMenuObject.sort((a,b) => (a.orderId > b.orderId) ? 1 : ((b.orderId > a.orderId) ? -1 : 0));    
    // console.log('Sidemenu Object:',this.sideMenuObject);
  }

  
}
